module.exports = __webpack_public_path__ + "img/Training_courses_img_4.639676bd.jpg";